import { flow } from 'fp-ts/function';
import { keyBy, mapValues, transform } from 'lodash/fp';
import { updateAppConfiguration } from '@mews-commander/data-access';
import { AsyncAction, CommanderThunkAction } from '@mews-commander/types';
import { createFetchAction } from '@mews-commander/utils';
import { CULTURE_INFO_FETCH, GLOBALIZATION_FETCH, TEXTS_FETCH } from '@mews/globalization';

const keyByCode = keyBy('code');
const transformCurrencies = transform(
    (acc, { cultureFormats, code, ...others }) =>
        (acc[code] = { ...others, cultureFormats: keyByCode(cultureFormats), code }),
    {}
);
const mapGlobalization = flow(
    mapValues(keyByCode),
    // @ts-expect-error $TSFixMeError: No overload matches this call.
    ({ currencies, ...others }) => ({ ...others, currencies: transformCurrencies(currencies) })
);

export const fetchGlobalization =
    (): CommanderThunkAction<AsyncAction> =>
    async (dispatch, _, { ensureQueryData }) => {
        const promise = ensureQueryData('globalization', 'get', {}).then(({ nowUtc, ...globalization }) => {
            updateAppConfiguration({ nowUtc });
            return mapGlobalization(globalization);
        });

        return dispatch(createFetchAction(GLOBALIZATION_FETCH, { promise }));
    };

export const fetchTexts =
    (languageCode: string): CommanderThunkAction<AsyncAction> =>
    async (dispatch, getState, { repositories }) => {
        const promise = repositories.languages
            .getTexts({ languageCode })
            .then(({ texts }) => ({ languageCode, texts }));

        return dispatch(createFetchAction(TEXTS_FETCH, { promise }));
    };

export const fetchCultureInfo =
    (cultureCode: string): CommanderThunkAction<AsyncAction> =>
    async (dispatch, getState, { repositories }) => {
        const promise = repositories.cultures.getInfo({ cultureCode });
        return dispatch(createFetchAction(CULTURE_INFO_FETCH, { promise }));
    };
